import {
  Decisao,
  Fonte,
  Referencia,
  ReferenciaNL,
} from '@/views/legislacao/types';

export const getDescricaoFonte = (fonte: Fonte): string => {
  return `${fonte.sgFonte} de ${fonte.dtPublicacaoFmt},`;
};

export const getLabelPagina = (nuPagina: string) => {
  return `p. ${nuPagina || '-'}`;
};

export const getURLPagina = (fonte: Fonte) => {
  return `/gcn-services/api/publico/origemnormaleg/arquivo/${fonte.hashCdFonte}/${fonte.hashCdOrigemNorma}`;
};

export const getURLArquivoInteriorTeor = (hashCdLegislacao: string) => {
  return `/gcn-services/api/publico/legislacao/find/${hashCdLegislacao}/inteiroteor`;
};

export const isMesmaFonte = (fonte1: Fonte, fonte2: Fonte) => {
  return (
    fonte1.sgFonte === fonte2.sgFonte &&
    fonte1.dtPublicacaoFmt === fonte2.dtPublicacaoFmt
  );
};

export const formatarFontes = (data: Fonte[] = []) => {
  const fontesUnicas = [] as Fonte[];

  for (const fonte of data) {
    if (fontesUnicas.find((fonte2) => isMesmaFonte(fonte, fonte2))) {
      continue;
    }

    fontesUnicas.push(fonte);
  }

  return fontesUnicas.map((fonte) => ({
    label: getDescricaoFonte(fonte),
    paginas: data
      .filter((f) => getDescricaoFonte(f) === getDescricaoFonte(fonte))
      .map((f) => ({
        label: getLabelPagina(f.nuPagina),
        href: getURLPagina(f),
      })),
  }));
};

export const getLabelDecisao = (decisao: Decisao) => {
  return (
    `${decisao.tpDecisao} ${decisao.nuDecisao}` +
    (decisao.deComentario ? ` - ${decisao.deComentario}` : '')
  );
};

export const getURLDownloadDecisao = (decisao: Decisao) => {
  return (
    '/gcn-services/api/publico/decisao/arquivo/' +
    decisao.hashCdLegislacao +
    '/' +
    decisao.hashCdDecisao
  );
};

export const getLabelReferenciaNL = (referenciaNL: ReferenciaNL) => {
  let label = `Matéria ${referenciaNL.deMateria}. ${referenciaNL.deTipoNorma} ${referenciaNL.nuNorma}`;

  if (referenciaNL.nuAno) {
    label += ` de ${referenciaNL.nuAno}.`;
  }

  if (referenciaNL.nmOrgaoExpedidor) {
    label += ` ${referenciaNL.nmOrgaoExpedidor}.`;
  }

  if (referenciaNL.deArtigo) {
    label += ` Artigo: ${referenciaNL.deArtigo}`;
  }

  if (referenciaNL.deParagrafo) {
    label += `, parágrafo: ${referenciaNL.deParagrafo}`;
  }

  if (referenciaNL.deInciso) {
    label += `, inciso: ${referenciaNL.deInciso}`;
  }

  if (referenciaNL.deAlinea) {
    label += `, alínea: ${referenciaNL.deAlinea}`;
  }

  if (referenciaNL.deNumero) {
    label += `, número: ${referenciaNL.deNumero}`;
  }

  return label;
};

export const getTiposVinculacaoDasReferencias = (referencias: Referencia[]) => {
  const tiposVinculacao = [] as string[];

  for (const referencia of referencias) {
    if (!tiposVinculacao.includes(referencia.deTipoVinculacao)) {
      tiposVinculacao.push(referencia.deTipoVinculacao);
    }
  }

  const referenciasPorTipoVinculacao = [] as {
    deTipoVinculacao: string;
    referencias: Referencia[];
  }[];

  for (const tipoVinculacao of tiposVinculacao) {
    const referenciasDoTipo = referencias.filter(
      (referencia) => referencia.deTipoVinculacao === tipoVinculacao
    );

    referenciasPorTipoVinculacao.push({
      deTipoVinculacao: tipoVinculacao,
      referencias: referenciasDoTipo,
    });
  }

  return referenciasPorTipoVinculacao;
};

export const getLabelReferencia = (referencia: Referencia) => {
  let label = `${referencia.deTipoNorma} ${referencia.nuNorma}/${referencia.nuAnoNorma}`;

  if (referencia.deComentario) {
    label += ` (${referencia.deComentario})`;
  }

  return label;
};

export const getURLReferencia = (referencia: Referencia) => {
  return `/legislacao/find/${referencia.cdLegislacao}`;
};
